<template>
  <div id="solutions">
  	<div class="solution-wrapper">
  		<b-container fluid class="solution-header">
	  		<b-row v-if="enable_filters">
	  			<b-col lg="2">
	  				<div class="sol-filter">
	  					<b-form-select v-model="selected">
					      <option :value="selected">Tag Subject</option>
					      <option value="a">Option A</option>
					      <option value="b" disabled>Option B (disabled)</option>
					      <optgroup label="Grouped Options">
					        <option :value="{'C':'3PO'}">Option  object value</option>
					        <option :value="{'R':'2D2'}">Another option with object value</option>
					      </optgroup>
					    </b-form-select>
	  				</div>
	  			</b-col>
	  			<b-col lg="2">
					<div class="sol-filter">
	  					<b-form-select v-model="selected">
					      <option :value="selected">Chapter</option>
					      <option value="a">A to Z</option>
					      <option value="a">Z to A</option>
					      <option value="a">Low Star</option>
					      <option value="a">High Star</option>
					    </b-form-select>
	  				</div>
	  			</b-col>
	  			<b-col lg="2">
					<div class="sol-filter">
	  					<b-form-select v-model="selected">
					      <option :value="selected">Date</option>
					      <option value="a">Accending</option>
					      <option value="a">Decending</option>
					    </b-form-select>
	  				</div>
	  			</b-col>
	  			<b-col lg="2"></b-col>
	  			<b-col lg="2">
					<div class="sol-filter">
	  					<b-form-input id="exampleInput1"
			                type="search"
			                v-model="search"
			                required
			                placeholder="Query Name">
			          </b-form-input>
	  				</div>
	  			</b-col>
	  			<b-col lg="2">
					<div class="sol-filter">
	  					<b-button type="submit" class="query-btn" variant="primary">Submit</b-button>
	  				</div>
	  			</b-col>
	  		</b-row>
  		</b-container>
  		<b-container fluid class="solution-container" v-for="(doubt,index) in user.doubts" :key="doubt.id">
  			<b-link class="solution-link note" v-bind:class="{'qds-active-border':doubt.doubt_status=='completed', noteactive:doubt.doubt_status=='completed'}" :to="'/dashboard/doubts/'+doubt.id">
  				<b-row>
  					<b-col lg="2" class="" style="display:flex;flex-direction: column;justify-content: center;">
  						<p class="date">{{get_human_date(doubt.created_at)}}</p>
  					</b-col>
  					<b-col lg="4">
  						<p>{{doubt.title}}</p>
  						<p class="doubt-description"><span class="qds-dot qds-active"></span> {{doubt.description.slice(0,50)}}...</p>
  					</b-col>
  					<b-col lg="5" class="sol-rating">
  						<!-- <p>Rate Solution:</p> -->
  						<!-- <div class="star-rating">
  							<font-awesome-icon icon="star" style="color: gold;" />
  							<font-awesome-icon icon="star" style="color: gold;" />
  							<font-awesome-icon icon="star" style="color: gold;" />
  							<font-awesome-icon icon="star" style="color: #fff;" />
  							<font-awesome-icon icon="star" style="color: #fff;" />
  						</div> -->
  					</b-col>
  					<b-col lg="1">

  						<span class="doubt-description sol-view" v-if="doubt.doubt_status=='completed'">Solved</span>
              <span class="doubt-description sol-view" v-else>Pending</span>

  					</b-col>
  				</b-row>
  			</b-link>
  		</b-container>
  		<!-- <b-container fluid class="solution-container">
  			<b-link class="solution-link note">
  				<b-row>
  					<b-col lg="2" class="text-center">
  						<p>26</p>
  						<p>Aug, 2017</p>
  					</b-col>
  					<b-col lg="4">
  						<p>Data Interpretation</p>
  						<p><span class="qds-dot"></span> Percentage, Level 1</p>
  					</b-col>
  					<b-col lg="5" class="sol-rating">
  						<p>Rate Solution:</p>
  						<div class="star-rating">
  							<font-awesome-icon icon="star" style="color: gold;" />
  							<font-awesome-icon icon="star" style="color: gold;" />
  							<font-awesome-icon icon="star" style="color: #fff;" />
  							<font-awesome-icon icon="star" style="color: #fff;" />
  							<font-awesome-icon icon="star" style="color: #fff;" />
  						</div>
  					</b-col>
  					<b-col lg="1">
  						<span class="sol-view">&plus;</span>
  					</b-col>
  				</b-row>
  			</b-link>
  		</b-container> -->
  		
  	</div>
  </div>
</template>

<script>
import dropdown from 'vue-my-dropdown';
import moment from 'moment';

export default {
  name: 'Solutions',
  data () {
    return {
      msg: 'Welcome to QdsPro',
      enable_filters:false
    }
  },
  computed: {
    user: function() {
      return this.$store.getters.user
    }
  },
  methods: {
    get_human_date(d) {
      let mom = moment(d);
      return mom.format('LL');
    },
  },
  selected:null,
  search:''
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.date {
  font-size: 0.8rem;
}
.solution-header {
	margin: 30px 0;
}
#solutions .custom-select,.sol-filter .form-control,.query-btn {
	border-radius: 20px;
	font-size: .8rem;
	line-height: 1.6rem;
}
.query-btn {
	width: 100%;
}
.sol-rating {
	display: inline-flex;
	justify-content: space-evenly;
	align-items: center;
}
.solution-link {
	background-color: #fff;
	margin: 10px 0px;
	display: block;
	color: black;
	padding: 20px;
}
.solution-link p {
	margin: 0;
}
.star-rating {
  line-height:32px;
  font-size:1.25em;
}
.sol-view {
	font-size: 3rem;
	line-height: 3rem;
	text-align: right;
}
.text-center {
	text-align: center;
}
.solution-link {
	border-left: 5px solid;
	border-color: #959090;
}
.qds-active-border {
	border-color:  #AACF37;
}

.doubt-description {
    display: none;
}

@media screen and (min-width: 1280px) {
  .doubt-description {
    display: block;
  }
  .doubt-description.sol-view {
    font-size:1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Solutions.vue